module.exports = __webpack_public_path__ + "i18n/ko.145ff1bfb0fd15e23176d7c3a4a0a95c.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1288
// module chunks = 60